var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayPrimaryRadiused(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#E71B4C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6378 10.2378C11.8251 10.1356 12.0533 10.1438 12.2328 10.2592L20.3994 15.5092C20.5664 15.6165 20.6673 15.8014 20.6673 15.9998C20.6673 16.1983 20.5664 16.3832 20.3994 16.4905L12.2328 21.7405C12.0533 21.8559 11.8251 21.8641 11.6378 21.7618C11.4505 21.6596 11.334 21.4632 11.334 21.2498V10.7498C11.334 10.5365 11.4505 10.3401 11.6378 10.2378ZM12.5007 11.8183V20.1814L19.0053 15.9998L12.5007 11.8183Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5007 20.1814V11.8183L19.0053 15.9998L12.5007 20.1814Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayPrimaryRadiused);
export default __webpack_public_path__ + "static/media/play_primary_radiused.55f7b598fe373d0314c20dc2ff9bd562.svg";
export { ForwardRef as ReactComponent };